import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useDispatch } from 'react-redux'
import { setModal } from '../../redux/modalSlice'
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons'

export default function NoteButton() {
  const dispatch = useDispatch()
  return (
    <button
      type="button"
      className="button has-background-grey has-text-white is-small mr-1 px-1 header-button-icon"
      onClick={() => dispatch(setModal({ title: `Add Note`, content: ``, type: 'add_note', is_active: true }))}
    >
      <FontAwesomeIcon icon={faPenToSquare} />
    </button>
  )
}
